<template lang="pug">
div
  template(v-if="showChart")
    apexchart(type="line" height="220" :options="chartOptions" :series="dataSeries")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AffiliateChart',
  props: ['propAffiliate'],
  data: () => ({
    metrics: null,
    showChart: false
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    chartOptions () {
      const context = this
      return {
        colors: [this.$vuetify.theme.themes[this.$theme].info200T48, this.$vuetify.theme.themes[this.$theme].primary500],
        chart: {
          height: 350,
          type: 'line',
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: [0, 2]
        },
        dataLabels: {
          enabled: false
        },
        labels: this.metrics.merchants.points.map(m => this.dateConverter(m.point)),
        xaxis: {
          type: 'datetime'
        },
        yaxis: [{ labels: { formatter: (value) => { return value/context.$currency.multiplier } }, tickAmount: 5 }, { opposite: true }]
      }
    },
    dataSeries () {
      let data = [
        {
          name: 'Commissions earned (RM)',
          type: 'column',
          data: this.metrics.earnings.points.map(m => (m.amount))
        }, {
          name: 'New merchants',
          type: 'line',
          data: this.metrics.merchants.points.map(m => (m.count))
        }
      ]
      return data
    }
  },
  mounted () {
    this.fetchMetrics()
    // setTimeout(() => {
    //   this.show = true
    // }, 2000)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchMetrics () {
      this.isFetching = true
      this.$axios.get(`/partners/charts?span=year`)
        .then(resp => {
          this.metrics = resp.data
          this.showChart = true
        })
        .catch(() => {
          // this.showMessage(['error', e.response.data[0]])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    dateConverter (date) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const getdate = new Date(date)
      return monthNames[getdate.getMonth()] + ' ' + getdate.getFullYear()
    }
  }
}
</script>